import { RoutingConfig } from '@nexelem/navigation';
import { ReactNode, createContext, useContext } from 'react';

type ConfigRouteContextProps = {
  routeConfig: RoutingConfig[];
  defaultPath: string;
};

const ConfigRouteContext = createContext<ConfigRouteContextProps>({ routeConfig: [], defaultPath: '/' });

type ConfigRouteProviderProps = {
  children: ReactNode;
  routeConfig: RoutingConfig[];
  defaultPath: string;
};

export const ConfigRouteProvider = ({ children, routeConfig, defaultPath }: ConfigRouteProviderProps) => (
  <ConfigRouteContext.Provider value={{ routeConfig, defaultPath }}>{children}</ConfigRouteContext.Provider>
);

export const useConfigRouteContext = () => {
  const context = useContext(ConfigRouteContext);
  if (!context) {
    throw new Error('useConfigRouteContext must be used within a ConfigRouteContext');
  }
  return context;
};
